import APIClient from '../../services/APIClient';
import { filterPlaceHolder, makeApiCall } from '../../services/ApiService';

export default {

    getUsers: (params:any) => makeApiCall({
        startCallMessage:'API: Fetching User Data',
        successMessage: 'API: Successfully Fetched User Data',
        failureMessage: 'API: Fetching User Failed',
        params,
        url:'/admin/users',
        method: APIClient.get,
        data: null,
        config: null,
        shouldShowNotifications: true,
        extractPath: (data) => data.users,
    }),

    createUser: (data: any) => {
        console.log('create user', data);
        return makeApiCall({
            startCallMessage:'API: Creating User',
            successMessage: 'API: Creating User Success',
            failureMessage: 'API: Creating Users Failed',
            data,
            url: '/admin/users',
            method: APIClient.post,
            config: null,
            extractPath: (data) => data,
        })
    },

    deleteUsers: (data: any) =>  makeApiCall({
        startCallMessage:'API: Deleting User',
        successMessage: 'API: Deleting User Success',
        failureMessage: 'API: Deleting User Failed',
        data,
        url: '/admin/users/delete',
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    }),

    triggerInvite: (data:any) => makeApiCall({
        startCallMessage:`API: Triggering Invite to users`,
        successMessage: 'API: Triggering Invite Successful',
        failureMessage: 'API: Triggering Invite Failed',
        url:'/admin/users/invite',
        method: APIClient.post,
        data: data,
        config: null,
        extractPath: (data) => data,
    }),

    editUsers: (data: any) => {
        console.log('edit user', data);
        return makeApiCall({
        startCallMessage: 'API: Editing User',
        successMessage: 'API: Editing User Success',
        failureMessage: 'API: Editing User Failed',
        data,
        url: '/admin/users' + (data._id ? `/${data._id}` : ''),
        method: APIClient.put,
        config: null,
        extractPath: (data) => data,
    })},

    changePassword: (data: any) => makeApiCall({
        startCallMessage: 'API: Editing User Password',
        successMessage: 'API: Editing User Password',
        failureMessage: 'API: Editing User Password Failed',
        data,
        url: '/admin/users/change-password',
        method: APIClient.post,
        config: null,
        extractPath: (data) => data,
    })

}
